export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ADMINLOGIN = "ADMINLOGIN";
export const ADMINLOGOUT = "ADMINLOGOUT";
export const STATUS = "STATUS";
export const DATA_TRANSACTIONS = "DATA_TRANSACTIONS";
export const DATA_USERS = "DATA_USERS";
export const DATA_TRANSACTIONS_MONTH = "ALL_DATA_TRANSACTIONS_MONTH";
